module.exports = __webpack_public_path__ + "static/media/objectivec.76ef3179.svg";